import './src/assets/styles/global.css';

// Import Swiper CSS globally to avoid hydration issues
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import React from 'react';
import { NotificationProvider } from './src/hooks/useNotifications';

export const wrapRootElement = ({ element }) => (
  <NotificationProvider>{element}</NotificationProvider>
);

// Disable browser's scroll restoration to prevent scroll jump on page refresh
// This is the most reliable fix for the ~20px scroll jump bug
export const onClientEntry = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  // Force unregister old service worker and clear caches
  // This fixes the issue where old service worker serves stale chunks after refactoring
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().then(() => {
          console.info('Service worker unregistered');
        });
      });
    });

    // Clear all caches to remove stale chunks
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
  }
};

// Control scroll behavior on route changes
// Return false to prevent Gatsby's default scroll restoration
// Return array [x, y] to scroll to specific position
export const shouldUpdateScroll = ({ routerProps: { location }, prevRouterProps }) => {
  // On page refresh (no previous location), scroll to top
  if (!prevRouterProps) {
    window.scrollTo(0, 0);
    return false;
  }

  // If navigating to a hash link, let browser handle it
  if (location.hash) {
    return true;
  }

  // For normal navigation, scroll to top
  window.scrollTo(0, 0);
  return false;
};
